var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30625 2.6125H18.6938C19.4283 2.6125 20 2.04109 20 1.30625C20 0.571711 19.4286 0 18.6938 0L1.30625 0.000284708C0.571712 0.000284708 0 0.57169 0 1.30653C0.00028469 2.04107 0.571697 2.61249 1.30625 2.61249V2.6125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30625 9.67402H18.6938C19.4283 9.67402 20 9.10262 20 8.36777C20 7.63324 19.4286 7.06152 18.6938 7.06152H1.30625C0.571712 7.06152 0 7.63293 0 8.36777C0.00028469 9.10231 0.571697 9.67402 1.30625 9.67402Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6938 16.7355C19.4283 16.7355 20 16.1641 20 15.4293C20 14.6948 19.4286 14.123 18.6938 14.123L1.30625 14.1233C0.571712 14.1233 0 14.6947 0 15.4296C0 16.1641 0.571405 16.7358 1.30625 16.7358L18.6938 16.7355Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b4f69fb36652689052e6952208986689.svg";
export { ForwardRef as ReactComponent };